var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
export class AccountSettingsAboutYourOrgViewModel {
    constructor(container) {
        this.authManager = container.authManager;
        this.healthSystemUIManager = container.healthSystemUIManager;
        this.consentConfigManager = container.consentConfigManager;
        this.adminUIManager = container.adminUIManager;
    }
    get orgName() {
        return this.authManager.orgName;
    }
    get isITAdmin() {
        return this.healthSystemUIManager.isITAdmin;
    }
    get isResearchAdmin() {
        return this.healthSystemUIManager.isResearchAdmin;
    }
    get isResearcher() {
        return this.healthSystemUIManager.isResearcher;
    }
    get isProvider() {
        return this.healthSystemUIManager.isProvider;
    }
    get healthSystem() {
        return this.healthSystemUIManager.healthSystem;
    }
    get consentConfig() {
        if (this.consentConfigManager.consentConfig.value === NOT_LOADED)
            return NOT_LOADED;
        if (this.consentConfigManager.consentConfig.value === null)
            return null;
        return this.consentConfigManager.consentConfig.value;
    }
    get orgEnabledRowInfo() {
        var _a, _b, _c, _d;
        if (this.consentConfig === NOT_LOADED)
            return [];
        if (this.healthSystem === NOT_LOADED)
            return [];
        const isDataAccessForPatientIdEnabled = (_b = (_a = this.healthSystem) === null || _a === void 0 ? void 0 : _a.allowDataAccessForPatientIdentification) !== null && _b !== void 0 ? _b : true;
        const isDataAccessForDeliveryEnabled = (_d = (_c = this.healthSystem) === null || _c === void 0 ? void 0 : _c.allowDataAccessForDataDelivery) !== null && _d !== void 0 ? _d : true;
        return [
            {
                title: "Data access for patient identification:",
                text: isDataAccessForPatientIdEnabled
                    ? "Approved researchers can identify eligible patients for recruitment based on their study's eligibility criteria or by MRN."
                    : "Approved researchers cannot identify eligible patients for recruitment based on their study's eligibility criteria. They can continue to identify patients by MRN.",
                allowed: isDataAccessForPatientIdEnabled,
                adminLink: this.isITAdmin || this.isResearchAdmin
                    ? () => this.adminUIManager.setCurrentAdminPage("DATA_SETTINGS", "ACCESS_PERMISSIONS")
                    : null,
            },
            {
                title: "Data access for data delivery:",
                text: isDataAccessForDeliveryEnabled
                    ? "Approved researchers can access identified patient data from consented patients for their study and research efforts."
                    : "Approved researchers must contact your organization to access identified patient data from consented patients for their study and research efforts.",
                allowed: isDataAccessForDeliveryEnabled,
                adminLink: this.isITAdmin || this.isResearchAdmin
                    ? () => this.adminUIManager.setCurrentAdminPage("DATA_SETTINGS", "ACCESS_PERMISSIONS")
                    : null,
            },
            {
                title: "Observational and interventional study consent:",
                text: "Patients can provide consent for study enrollment and identified data access.",
                allowed: true,
                alwaysAllowed: true,
                adminLink: null,
            },
        ];
    }
    get adminEmail() {
        if (this.healthSystem === NOT_LOADED || this.healthSystem === null)
            return null;
        return this.healthSystem.adminEmail;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsAboutYourOrgViewModel.prototype, "orgName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsAboutYourOrgViewModel.prototype, "isITAdmin", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsAboutYourOrgViewModel.prototype, "isResearchAdmin", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsAboutYourOrgViewModel.prototype, "isResearcher", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsAboutYourOrgViewModel.prototype, "isProvider", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsAboutYourOrgViewModel.prototype, "healthSystem", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsAboutYourOrgViewModel.prototype, "consentConfig", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], AccountSettingsAboutYourOrgViewModel.prototype, "orgEnabledRowInfo", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsAboutYourOrgViewModel.prototype, "adminEmail", null);
